var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.21411 13C10.804 13 13.7141 10.0899 13.7141 6.5C13.7141 2.91015 10.804 0 7.21411 0C3.62426 0 0.714111 2.91015 0.714111 6.5C0.714111 10.0899 3.62426 13 7.21411 13ZM10.8713 4.97352C11.2249 4.54924 11.1675 3.91868 10.7433 3.56511C10.319 3.21155 9.68841 3.26887 9.33485 3.69315L7.12578 6.34403C6.77906 6.76009 6.58415 6.99043 6.42853 7.13198L6.42259 7.13736L6.41618 7.13254C6.24838 7.00567 6.03342 6.79391 5.65045 6.41095L5.0324 5.7929C4.64187 5.40237 4.00871 5.40237 3.61818 5.7929C3.22766 6.18342 3.22766 6.81659 3.61818 7.20711L4.23624 7.82517L4.27707 7.866L4.27707 7.86601C4.60357 8.19262 4.91765 8.50683 5.20989 8.72781C5.53726 8.97535 5.96598 9.20813 6.51539 9.1832C7.0648 9.15828 7.47068 8.88765 7.77429 8.61149C8.04532 8.36496 8.32967 8.02361 8.62526 7.66877L8.62526 7.66876L8.66222 7.6244L10.8713 4.97352Z",
    fill: "#E8A941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.da01072fa9de1fc32df0a136b4aa566b.svg";
export { ForwardRef as ReactComponent };